import React from 'react';
import { LandingTemplate } from '@/components/landing/landingTemplate';
import { GenerateLandingLinkService } from '@/services';
import { landingCutoutImageConfig } from '@/data/landingConfig/landingCutoutImageConfig';
import { AggregateSchema } from '../AggregateSchema';
import { schemaObject_CutoutImage } from './schemaObject';

interface Props {}
const CutoutImage: React.FC<Props> = () => {
	return (
		<>
			<AggregateSchema schema={schemaObject_CutoutImage} />
			<LandingTemplate
				data={landingCutoutImageConfig}
				funnelLinkService={GenerateLandingLinkService.funnelRemoveBGV3()}
			/>
		</>
	);
};

export default CutoutImage;
